import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ShipmentHistoryName from "../../components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryName.tsx";
import {useLocationFormState} from "../../components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryUpdateForm";
import ShipmentHistoryUpdateFormProvider from "../../components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ShipmentHistoryUpdateEditPage = () => {
    
    useTitle(t`Update Shipment History`);

    const { shipmentHistoryId: id } = useParams();
    
    return (
        <Box data-testid="ShipmentHistory-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ShipmentHistory-update-title"
                    >
                        <Trans>Edit Shipment History</Trans>:  <ShipmentHistoryName id={id}/>
                    </Typography>
                    <ShipmentHistoryUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ShipmentHistoryUpdateEditPage;
